import * as tslib_1 from "tslib";
// Core components
import { AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { isArray } from "util";
// Third party components
import { MatDialog } from "@angular/material";
import { FieldType } from "@ngx-formly/material";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom components
import { ConfigService } from 'src/app/shared/services/config.service';
import { FileService } from "src/app/shared/services/file.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { LightboxDialogComponent } from "../../dialogs/lightbox-dialog/lightbox-dialog.component";
var FileUploaderStructureTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FileUploaderStructureTypeComponent, _super);
    function FileUploaderStructureTypeComponent(helperService, translateService, toastrService, fileService, configService, dialog) {
        var _this = _super.call(this) || this;
        _this.helperService = helperService;
        _this.translateService = translateService;
        _this.toastrService = toastrService;
        _this.fileService = fileService;
        _this.configService = configService;
        _this.dialog = dialog;
        _this.subscriptions = [];
        _this.triggerFileUpload = false;
        _this.triggerFileReset = false;
        _this.importFormSubmitBtnOptions = {
            active: false,
            text: _this.translateService.instant("common.cta.import"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            customClass: "mt-2"
        };
        _this.uploadedFiles = [];
        _this.imageLoader = false;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        // Set default tempateOptions
        if (typeof this.to.allowedFilesNumber === "undefined") {
            this.to.allowedFilesNumber = 1;
        }
        if (typeof this.to.allowedFilesExtensions === "undefined") {
            this.to.allowedFilesExtensions = "*";
        }
        if (typeof this.to.defaultValue === "undefined") {
            this.to.defaultValue = [];
        }
        // Set initial values
        this.filesToUpload = this.to.defaultValue;
        if (this.formControl.value
            && this.previousValue !== this.formControl.value) {
            this.previousValue = JSON.parse(JSON.stringify(this.formControl.value));
            this.initFiles(this.formControl.value);
        }
        // Handle form value changes (these are the uploaded files)
        this.subscriptions.push(this.formControl.valueChanges.subscribe(function (res) {
            if (res === _this.previousValue) {
                return;
            }
            _this.filesToUpload = [];
            _this.previousValue = JSON.parse(JSON.stringify(res));
            _this.initFiles(res);
        }));
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle event "uploadFiles" emitted from file-uploader component
     *
     * @since 1.0.0
     *
     * @param files Files to upload
     * @returns undefined
     */
    FileUploaderStructureTypeComponent.prototype.onUploadFiles = function (files) {
        var e_1, _a;
        var _this = this;
        if (this.options.formState.disabled) {
            console.warn('Block upload because field is disabled'); //@todo: translate
            return;
        }
        else {
            this.importFormSubmitBtnOptions.disabled = false;
        }
        // Check total file number (if too much don't even try to upload anything)
        var currentFilesNumber = this.uploadedFiles.length + this.filesToUpload.length;
        if (currentFilesNumber >= this.to.allowedFilesNumber) {
            this.toastrService.warning(this.translateService.instant("common.errors.maxElementsReached"));
            return;
        }
        var currentFilesNames = tslib_1.__spread(this.uploadedFiles, this.filesToUpload).map(function (file) { return file.originalName; });
        this.importFormSubmitBtnOptions.active = true;
        // You could upload it like this:
        var formData = new FormData();
        var counter = 1;
        var _loop_1 = function (givenFile) {
            var fileEntry = givenFile.fileEntry;
            if (currentFilesNames.includes(fileEntry.name)) {
                this_1.toastrService.warning(this_1.translateService.instant("common.errors.elementExists"));
                return { value: void 0 };
            }
            fileEntry.file(function (file) {
                var name = "file[]";
                formData.append(name, file, givenFile.relativePath);
                counter++;
                if (counter === files.length + 1) {
                    var uploadFilesSubscription = _this.fileService
                        .uploadImportingFiles(formData)
                        .pipe(finalize(function () { return (_this.importFormSubmitBtnOptions.active = false); }))
                        .subscribe(function (res) {
                        // Accept all-and-only last (this.to.allowedFilesNumber)
                        // files (this is needed! do not remove!)
                        var files = [];
                        if (res.status) {
                            files = res.files.slice(-_this.to.allowedFilesNumber);
                        }
                        // If available, call the callback
                        if (typeof _this.to.callback === "function") {
                            _this.to.callback(res, _this.model);
                        }
                        // Handle res status
                        if (res.status) {
                            _this.triggerFileReset = !_this.triggerFileReset; // Reset drop-zone area
                            _this.updateUpdatedFiles(files);
                            return;
                        }
                        if (res.message) {
                            _this.toastrService.error(_this.translateService.instant("common.words.warning"), res.message);
                            return;
                        }
                        _this.toastrService.error(_this.translateService.instant("common.errors.unknown"));
                    }, function (err) {
                        // Choose one of the following error handling
                        // method. The first one show a message right
                        // under the form fields (if the form is properly
                        // setted), the second one show toastr
                        // notifications for each error
                        // this.helperService.handleFormError(this.form, err);
                        _this.helperService.handleError(err);
                    });
                    _this.subscriptions.push(uploadFilesSubscription);
                }
            });
        };
        var this_1 = this;
        try {
            for (var files_1 = tslib_1.__values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                var givenFile = files_1_1.value;
                var state_1 = _loop_1(givenFile);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Init element uploaded files
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.initFiles = function (files) {
        var _this = this;
        var apiHost = this.configService.apiHost;
        // Update image previews list
        this.uploadedFiles = [];
        if (files) {
            files.forEach(function (file) {
                var path = file.path;
                // if (path.startsWith("public")) {
                if (path.substring(0, apiHost.length) !== apiHost) {
                    var newPath = apiHost + "\\" + path;
                    file.path = newPath;
                }
                // }
                _this.uploadedFiles.push(file);
            });
        }
        else {
            this.uploadedFiles = [];
        }
    };
    /**
     * Current files to upload
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.updateUpdatedFiles = function (filesArray /*, setValue: boolean*/) {
        var _this = this;
        var files = filesArray;
        // if (typeof setValue === "undefined") {
        //   setValue = false;
        // }
        var apiHost = this.configService.apiHost;
        // Update image previews list
        if (files) {
            files.forEach(function (file) {
                var path = file.path;
                // if (path.stkartsWith("public")) {
                var newPath = apiHost + "\\" + path;
                file.path = newPath;
                // }
                if (path.includes("temp")) {
                    _this.filesToUpload.push(file);
                    // Prevent visualization of more previews than allowed
                    _this.filesToUpload = _this.filesToUpload.slice(-_this.to.allowedFilesNumber);
                }
                else {
                    // this.uploadedFiles.push(file);
                }
            });
        }
        else {
            this.filesToUpload = [];
        }
        // Set value in model/form
        if (this.model.files && Array.isArray(this.model.files)) {
            // here we're merging previous uploaded files with new ones
            this.filesToUpload.forEach(function (file) {
                _this.model.files.push(file);
            });
        }
        if (Array.isArray(this.value)) {
            // here we're merging previous uploaded files with new ones
            this.filesToUpload.forEach(function (file) {
                _this.value.push(file);
            });
        }
    };
    /**
     * Remove given item from:
     * 1) File previews
     * 2) Field's value
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.onRemove = function (file) {
        // Remove file from previews
        this.filesToUpload = this.filesToUpload.filter(function (item) { return item._id !== file._id; });
        var key = this.key;
        // Remove file from field value
        if (typeof file._id !== "undefined" && this.model[key] === file._id) {
            this.model[key] = null;
        }
        if (isArray(this.model[key])) {
            this.model[key] = this.model[key].filter(function (item) { return item._id !== file._id; });
        }
    };
    /**
     * Remove given item from uploaded files
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.onRemoveUploadedFile = function (file) {
        // Remove file from previews
        this.uploadedFiles = this.uploadedFiles.filter(function (item) { return item._id !== file._id; });
        var key = this.key;
        // Remove file from model/form
        if (typeof file._id !== "undefined" && this.model[key] === file._id) {
            this.model[key] = null;
        }
        if (isArray(this.model[key])) {
            this.model[key] = this.model[key].filter(function (item) { return item._id !== file._id; });
        }
        if (Array.isArray(this.value)) {
            this.value.splice(this.value.indexOf(file), 1);
        }
    };
    /**
     * Handle click on a image preview and opens it in a dialog
     *
     * @since 1.0.0
     */
    FileUploaderStructureTypeComponent.prototype.onOpenImage = function (file) {
        this.dialog.open(LightboxDialogComponent, {
            data: {
                url: file.path,
                createdAt: file.createdAt
            },
            panelClass: "lightbox-dialog"
        });
    };
    return FileUploaderStructureTypeComponent;
}(FieldType));
export { FileUploaderStructureTypeComponent };
